export type PublicBrandConfig = {
  readonly brandName: string;
  readonly siteOrigin: string;
  readonly sisterSiteOrigin: string | null;
};

function stripTrailingSlash(value: string): string {
  return value.replace(/\/$/, '');
}

function getEnvString(key: string): string | undefined {
  const raw = (import.meta.env as Record<string, string | undefined>)[key];
  if (typeof raw === 'string' && raw.trim().length > 0) {
    return raw.trim();
  }
  return undefined;
}

function hostnameFallbackBrand(): string {
  if (typeof window === 'undefined') {
    return 'App';
  }
  const host = window.location.hostname.trim();
  return host.length > 0 ? host : 'App';
}

function resolveSiteOrigin(): string {
  const fromEnv = getEnvString('VITE_PUBLIC_SITE_ORIGIN');
  if (fromEnv !== undefined) {
    return stripTrailingSlash(fromEnv);
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return stripTrailingSlash(window.location.origin);
  }
  return '';
}

function resolveSisterSiteOrigin(): string | null {
  const fromEnv =
    getEnvString('VITE_PUBLIC_SISTER_SITE_ORIGIN') ?? getEnvString('VITE_ADMIN_APP_BASE_URL');
  if (fromEnv !== undefined) {
    return stripTrailingSlash(fromEnv);
  }
  return null;
}

/** Brand + public origins for SEO/chrome. Never hardcode a marketing domain. */
export function getPublicBrandConfig(): PublicBrandConfig {
  const brandName =
    getEnvString('VITE_PUBLIC_BRAND_NAME') ??
    getEnvString('VITE_PLATFORM_BRAND_DISPLAY_NAME') ??
    hostnameFallbackBrand();

  return {
    brandName,
    siteOrigin: resolveSiteOrigin(),
    sisterSiteOrigin: resolveSisterSiteOrigin(),
  };
}